import React from "react";

import Author from "author/components/Author/Author";
import Authorize from "components/Library/Authorize/Authorize";
import Events from "events/components/Events";
import SearchResults from "search/components/SearchResults";
import Subscription from "subscriptions/components/Subscription";
import Subscriptions from "subscriptions/components/Subscriptions";
import UserSettings from "users/components/UserSettings/UserSettings";
import SavedStories from "users/components/SavedStories/SavedStories";
import Legal from "legal/components/Legal/Legal";
import About from "about/components/About/About";
import StoryPermalink from "dashboard/containers/StoryPermalink";
import SectionStream from "dashboard/containers/SectionStream";
import TagStream from "dashboard/containers/TagStream";

import { loadStory } from "actions/storiesStream";
import { getNewsletter, populateSubscription } from "subscriptions/actions/subscriptions";
import { getRedirectPath } from "utils/server";
import {
  setSectionWithTag,
  getSection,
} from "actions/navigation";
import { getAuthor } from "author/actions/author";

import { URL_ID_REGEXP } from "config/constants";

const oldPermalinkRoute = "/:slug([A-Za-z0-9-]+-)?:id([0-9]+).html";
const storyPermalinkRoute = `/:slug([A-Za-z0-9-]+?-)?:id${URL_ID_REGEXP}.html`;
const newsletterPermalinkRoute = `/newsletters/:subscription([A-Za-z0-9-]+)?-:newsletter${URL_ID_REGEXP}.html`;

export const routes = [
  {
    path: "/",
    exact: true,
    render: (props) => <SectionStream {...props} slug="top" />,
    fetchData: (req, match, dispatch) => dispatch(getSection("top")),
  },
  {
    path: "/authors/:username",
    exact: true,
    component: Author,
    fetchData: (req, match, dispatch) => dispatch(getAuthor(match.params.username)),
  },
  {
    path: "/authorize",
    exact: true,
    component: Authorize,
  },
  {
    path: "/results",
    exact: true,
    component: SearchResults,
  },
  {
    path: "/legal",
    exact: true,
    component: Legal,
  },
  {
    path: "/about",
    exact: true,
    component: About,
  },
  {
    path: "/events",
    exact: true,
    component: Events,
  },
  {
    path: "/newsletters",
    exact: true,
    component: Subscriptions,
  },
  {
    path: newsletterPermalinkRoute,
    exact: true,
    component: Subscription,
    fetchData: (req, match, dispatch, context) => Promise.all([
      getRedirectPath(req, match.params.newsletter, context),
      dispatch(getNewsletter(match.params.newsletter)),
      dispatch(populateSubscription(match.params.subscription)),
    ]),
  },
  {
    path: "/newsletters/:subscription",
    exact: true,
    component: Subscription,
    fetchData: (req, match, dispatch) => dispatch(populateSubscription(match.params.subscription)),
  },
  {
    path: "/users/settings",
    exact: true,
    component: UserSettings,
  },
  {
    path: "/users/saved-stories",
    exact: true,
    component: SavedStories,
  },
  {
    path: "/tag/:tag",
    exact: true,
    component: TagStream,
    fetchData: (req, match, dispatch) => dispatch(setSectionWithTag(match.params.tag)),
  },
  {
    path: storyPermalinkRoute,
    component: StoryPermalink,
    fetchData: (req, match, dispatch, context) => {
      if (req.query.preview || req.query.revision) return Promise.resolve();
      return Promise.all([
        getRedirectPath(req, match.params.id, context),
        dispatch(loadStory({ story: match.params.id })),
      ]);
    },
  },
  {
    path: oldPermalinkRoute,
    render: () => { null },
    fetchData: (req, match, dispatch, context) => getRedirectPath(req, match.params.id, context),
  },
  {
    path: "/community/:user",
    fetchData: (req, match, dispatch, context) => {
      context.status = 302;
      context.path = `/authors/${match.params.user}`;
      return Promise.resolve();
    },
  },
  {
    path: "/:section",
    render: (props) => <SectionStream {...props} slug={props.match.params.section} />,
    fetchData: (req, match, dispatch) => dispatch(getSection(match.params.section)),
  },
];



// WEBPACK FOOTER //
// ./src/routes.js